const videoSource18 = [
  {
    id: "video16",
    src: require("./1_11.mp4"),
  },
];

export default videoSource18;
